import React from 'react'
import { Link } from 'react-router-dom'
import { LanguageConsumer } from '../lib/LanguageContext'
import Logout from '../Logout'
import Footer from '../Footer'
import './NotAuthorized.css'

const NotAuthorized = (props) => {

  let queryString = props.queryString

  return (
     <LanguageConsumer>
        {({polyglot}) =>
         (<div className='Not-Authorized'>
           <Logout handleLogout={props.handleLogout}/>
           <div className='ErrorBody not-authorized'>
                  <div className='ErrorHeader'>
                      <h1>{polyglot.t('notAuthorizedErrorMessage')}</h1>
                  </div>
                  <div className='ErrorSubtitle'>
                      <h3>{polyglot.t('fetchErrorSubtitle')}</h3>
                  </div>
                  <div className='ErrorLink'>
                      <Link to='/'>{polyglot.t('fetchErrorLink')}</Link>
                  </div>
                  <div className='ErrorLink'>
                      <Link to={`/login?next=${props.location}${props.queryString}`}>{polyglot.t('login')}</Link>
                  </div>
            </div>
            <Footer/>
          </div>)}
     </LanguageConsumer>
  )
}

export default NotAuthorized



// WEBPACK FOOTER //
// ./src/components/NotAuthorized.js